import { render, staticRenderFns } from "./Materiallist.vue?vue&type=template&id=27a85833&scoped=true"
import script from "./Materiallist.vue?vue&type=script&lang=js"
export * from "./Materiallist.vue?vue&type=script&lang=js"
import style0 from "./Materiallist.vue?vue&type=style&index=0&id=27a85833&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a85833",
  null
  
)

export default component.exports